<template>
  <div id="new-courier">
    <BreadCrumb :items="breadcrumbItems" />
    <v-row>
      <v-col cols="12">
        <v-card v-if="loading && parameterID" elevation="2" class="py-5 px-5 mt-1 text-center">
          Aguarde, buscando dados
          <div class="mt20"></div>
          <v-progress-linear indeterminate class="mb-0"></v-progress-linear>
        </v-card>
        <v-card v-else elevation="2" class="py-5 mt-1">
          <div class="header d-flex justify-space-between pr-5 pb-5">
            <h1>{{ namePage }}</h1>
          </div>

          <v-form @submit.prevent="submit">
            <v-row>
              <v-col cols="12">
                <div class="divider mt-3 mb-5"></div>
              </v-col>
            </v-row>

            <v-row class="px-9">
              <v-col cols="12">
                <h6>Dados Gerais</h6>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="generalData.name"
                  label="Nome (Obrigatório)"
                  required
                  :rules="rules"
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="generalData.nickName"
                  label="Apelido"
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="generalData.cpf"
                  label="CPF (Obrigatório)"
                  required
                  :rules="rules"
                  :disabled="onlyView"
                  v-mask="'###.###.###-##'"
                  @change="updateBankData"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="generalData.cnhNumber"
                  label="CNH (Obrigatório)"
                  required
                  :rules="rules"
                  :disabled="onlyView"
                  autocomplete="off"
                  v-mask="'#########-##'"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="generalData.phoneNumber"
                  label="Telefone (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                  v-mask="'(##) #####-####'"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="accessData.email"
                  label="Email"
                  type="email"
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <div class="divider mt-3 mb-5"></div>
              </v-col>
            </v-row>

            <v-row class="px-9">
              <v-col cols="12">
                <h6>Endereço</h6>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="addressData.cep"
                  label="CEP (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                  v-mask="'#####-###'"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-select
                  v-model="addressData.state"
                  :rules="rules"
                  label="Estado (Obrigatório)"
                  :items="getStates"
                  item-text="name"
                  item-value="id"
                  :disabled="onlyView"
                  @change="fetchCitiesByID"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="3">
                <v-select
                  v-model="addressData.cityId"
                  :rules="rules"
                  label="Cidade (Obrigatório)"
                  :items="getCities"
                  item-text="name"
                  item-value="id"
                  :disabled="disableCity"
                  :loading="loadingCity"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="addressData.neighborhood"
                  label="Bairro (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="addressData.street"
                  label="Lougradouro (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="2">
                <v-text-field
                  v-model="addressData.number"
                  label="Número (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="addressData.complement"
                  label="Complemento"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <div class="divider mt-3 mb-5"></div>
              </v-col>
            </v-row>

            <v-row class="px-9">
              <v-col cols="12">
                <h6>Dados do Veículo</h6>
              </v-col>

              <v-col cols="12" md="3">
                <v-select
                  v-model="vehicleData.typeVehicleId"
                  label="Tipo de Veículo (Obrigatório)"
                  :rules="rules"
                  :items="getVehiclesTypes"
                  item-text="name"
                  item-value="id"
                  :disabled="onlyView"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="3" v-if="vehicleData.typeVehicleId === '4a9cebb6-142a-4d9b-a79b-606c5e1250ae'">
                <v-text-field
                  v-model="vehicleData.description"
                  label="Descrição"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="vehicleData.renavam"
                  label="RENAVAM (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="3">
                <v-text-field
                  v-model="vehicleData.plate"
                  label="Placa (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                  v-mask="'NNNNNNN'"
                  v-uppercase
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="!isTranshipmentCourier">
              <v-col cols="12">
                <div class="divider mt-3 mb-5"></div>
              </v-col>
            </v-row>

            <v-row class="px-9" v-if="!isTranshipmentCourier">
              <v-col cols="12">
                <h6>Dados Bancários</h6>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="bankData.bankName"
                  label="Banco (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="bankData.agency"
                  label="Agência (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="bankData.account"
                  label="Conta (Obrigatório)"
                  :rules="rules"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="bankData.cpfOrCnpjHolder"
                  label="CPF/CNPJ do titular da conta"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                  v-mask="'###.###.###-##'"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="bankData.pixKey"
                  label="PIX"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <p class="label-radio-group">Títular da conta (Obrigatório)</p>
                <v-radio-group v-model="bankData.isHolder" row :disabled="onlyView" @change="updateBankData">
                  <v-radio label="Sim" :value="true"></v-radio>
                  <v-radio label="Não" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <div class="divider mt-3 mb-5"></div>
              </v-col>
            </v-row>

            <v-row class="px-9">
              <v-col cols="12">
                <h6>Dados de Acesso</h6>
              </v-col>
              <v-col cols="12" md>
                <v-text-field
                  v-model="generalData.cpf"
                  label="CPF"
                  type="text"
                  readonly
                  disabled
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md>
                <v-text-field
                  v-model="accessData.password"
                  label="Senha (Obrigatório)"
                  :rules="rules"
                  type="password"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md>
                <v-text-field
                  v-model="accessData.confirmPassword"
                  label="Confirmar Senha (Obrigatório)"
                  :rules="rules"
                  type="password"
                  required
                  :disabled="onlyView"
                  autocomplete="off"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <div class="divider mt-3 mb-5"></div>
              </v-col>
            </v-row>

            <v-row class="px-9">
              <v-col cols="12">
                <h6>Fotos dos documentos</h6>
              </v-col>

              <v-col v-for="(type, index) in getTypeDocumentPhotos" :key="type.name" cols="12" lg="3">
                <p>{{ type.name }}</p>
                <div class="area-drop" v-if="!onlyView">
                  <div class="message-drop">
                    <v-icon> mdi-folder-multiple-image </v-icon>
                    <p>Selecione ou arraste suas imagens aqui.</p>
                  </div>
                  <input required type="file" @change="(e) => addImages(e, type.id, index)" />
                </div>
                <div v-if="getFiles[index].dataFiles" class="bg-imagem mt15">
                  <img
                    :src="getFiles[index].dataFiles"
                    alt=""
                    style="min-height: 350px; width: 100%; object-fit: contain; background-size: contain"
                  />
                  <div class="bg-imagem--hover" v-if="!onlyView">
                    <v-icon dark @click="removeImage(type.id, index)"> mdi-close </v-icon>
                  </div>
                </div>
              </v-col>
            </v-row>

            <v-row class="px-9">
              <v-col cols="12" class="d-flex justify-end">
                <v-btn large :color="onlyView ? 'info' : 'error'" :class="onlyView ? '' : 'mr-5'" @click="cancel()">
                  {{ onlyView ? 'VOLTAR' : 'CANCELAR' }}
                </v-btn>
                <v-btn
                  v-if="!onlyView"
                  large
                  color="success"
                  :loading="loadingToCreate"
                  @click="submit()"
                  :disabled="!checkForm()"
                >
                  SALVAR
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <MessagesError :errors="errors" :type="errorsType" @closeMessages="errors = []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import Base64Mixin from '../../../mixins/base64.mixin';
import MessagesError from '../../../components/MessagesError.vue';

export default {
  name: 'NewTranshipment',
  components: {
    BreadCrumb,
    MessagesError
  },
  mixins: [Base64Mixin],
  data: () => ({
    loadingToCreate: false,
    errors: [],
    errorsType: null,
    data: {},
    loadingCity: false,
    loading: false,
    files: [{}, {}, {}, {}],
    generalData: {
      name: null,
      nickName: null,
      cpf: null,
      cnhNumber: null,
      phoneNumber: null
    },
    addressData: {
      cep: null,
      state: null,
      cityId: null,
      neighborhood: null,
      street: null,
      number: null,
      complement: null
    },
    vehicleData: {
      typeVehicleId: null,
      renavam: null,
      plate: null,
      description: null
    },
    bankData: {
      bankName: null,
      agency: null,
      account: null,
      cpfOrCnpjHolder: null,
      pixKey: null,
      isHolder: true
    },
    accessData: {
      email: null,
      password: null,
      confirmPassword: null
    },
    rules: [(value) => !!value || 'Required.']
  }),
  computed: {
    ...mapGetters('AdressStore', ['getStates', 'getCities']),
    ...mapGetters('CouriersStore', ['getVehiclesTypes', 'getTypeDocumentPhotos']),
    breadcrumbItems() {
      return [
        {
          text: 'Início',
          disabled: false,
          to: '/start',
          exact: true
        },
        {
          text: 'Entregadores',
          disabled: false,
          to: '/couriers',
          exact: true
        },
        {
          text: this.namePage,
          disabled: true
        }
      ];
    },
    disableCity() {
      if (this.onlyView) {
        return true;
      }

      return !this.addressData.state;
    },
    isTranshipmentCourier() {
      return this.$route.name === 'ViewTranshipmentCourier';
    },
    onlyView() {
      return this.$route.name === 'ViewCourier' || this.$route.name === 'ViewTranshipmentCourier';
    },
    namePage() {
      if (this.parameterID) {
        if (this.onlyView) {
          return 'Visualizar entregador';
        } else {
          return 'Editar entregador';
        }
      }

      return 'Novo entregador';
    },
    getFiles() {
      return this.files;
    },
    parameterID() {
      return this.$route.params.id;
    },
    isCompanyInRoute() {
      return Number(this.$route.params.type);
    }
  },
  mounted() {
    this.fetchAllStates();
    this.fetchAllVehiclesTypes();
    this.fetchAllTypeDocumentPhotos();

    if (this.isTranshipmentCourier) {
      this.getTranshipmentCourier();
    } else if (this.parameterID) {
      this.courierEdit();
    }
  },
  methods: {
    ...mapActions('TranshipmentStore', ['getManageTranshipmentDeliverer']),
    ...mapActions('CouriersStore', [
      'fetchCourierByID',
      'fetchVehiclesTypes',
      'fetchTypeDocumentPhotos',
      'createCouriers',
      'editCouriers'
    ]),
    ...mapActions('AdressStore', ['fetchStates', 'fetchCities']),
    removeImage(type, indexInput) {
      this.files = this.files.map((item, index) => {
        if (index === indexInput) {
          return {};
        }
        return item;
      });
    },
    updateBankData() {
      this.bankData.isHolder
        ? (this.bankData.cpfOrCnpjHolder = this.generalData.cpf)
        : (this.bankData.cpfOrCnpjHolder = '');
    },
    async addImages(event, type, indexInput) {
      const newItem = [...event.target.files][0];
      const dataFiles = await this.toBase64(newItem);
      this.files = this.files.map((item, index) => {
        if (index === indexInput) {
          return {
            name: newItem.name,
            typeDocumentPhotoId: type,
            dataFiles: dataFiles
          };
        }

        return item;
      });
    },
    setValidDocument(bool = true) {
      this.isValidDocument = bool;

      if (bool === true) {
        setTimeout(() => {
          this.isValidDocument = false;
        }, 3000);
      }
    },
    checkInvalid(campo) {
      if (campo === null || campo === '') {
        return true;
      } else return false;
    },
    checkForm() {
      if (
        this.checkInvalid(this.generalData.name) ||
        this.checkInvalid(this.generalData.cpf) ||
        this.checkInvalid(this.generalData.cnhNumber) ||
        this.checkInvalid(this.generalData.phoneNumber) ||
        this.checkInvalid(this.addressData.cep) ||
        this.checkInvalid(this.addressData.neighborhood) ||
        this.checkInvalid(this.addressData.state) ||
        this.checkInvalid(this.addressData.cityId) ||
        this.checkInvalid(this.addressData.street) ||
        this.checkInvalid(this.addressData.number) ||
        this.checkInvalid(this.vehicleData.typeVehicleId) ||
        this.checkInvalid(this.vehicleData.renavam) ||
        this.checkInvalid(this.vehicleData.plate) ||
        this.checkInvalid(this.bankData.bankName) ||
        this.checkInvalid(this.bankData.agency) ||
        this.checkInvalid(this.bankData.account) ||
        (this.checkInvalid(this.accessData.password) && !this.parameterID) ||
        (this.checkInvalid(this.accessData.confirmPassword) && !this.parameterID)
      ) {
        return false;
      } else {
        return true;
      }
    },
    async submit() {
      if (!this.checkForm()) {
        this.errors = ['Campos inválidos! Verifique se você não esqueceu algum campo obrigatório.'];
        this.errorsType = 'info';
        return;
      }
      this.loadingToCreate = true;

      let dataFilesValid = this.files.filter((item) => Object.keys(item).length);

      let removeBase64 = dataFilesValid.map((item) => {
        return {
          ...item,
          dataFiles: item.dataFiles.split('base64,')[1]
        };
      });

      let body = {
        type: this.typeTranshipmentSelected,
        params: {
          ...this.generalData,
          ...this.accessData,
          documentPhotos: removeBase64,
          addressData: this.addressData,
          bankData: this.bankData,
          vehicleData: this.vehicleData
        }
      };

      if (this.parameterID) {
        body.params.id = this.parameterID;
      }

      try {
        const status = await (this.parameterID ? this.editCouriers(body) : this.createCouriers(body));

        if (status.success) {
          this.success = true;
          this.$router.push('/couriers');
        } else {
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingToCreate = false;
      }
    },
    async fetchAllTypeDocumentPhotos() {
      try {
        await this.fetchTypeDocumentPhotos();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchAllRoles() {
      try {
        await this.fetchRoles();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchAllVehiclesTypes() {
      try {
        await this.fetchVehiclesTypes();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchAllStates() {
      try {
        await this.fetchStates();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchCitiesByID() {
      this.loadingCity = true;
      try {
        await this.fetchCities(this.addressData.state);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingCity = false;
      }
    },
    cancel() {
      this.$router.back();
    },
    setValidPassword(bool = true) {
      this.isValidPassword = bool;

      if (bool === true) {
        setTimeout(() => {
          this.isValidPassword = false;
        }, 3000);
      }
    },
    async courierEdit() {
      this.loading = true;
      try {
        const data = await this.fetchCourierByID(this.parameterID);

        this.generalData.name = data.name;
        this.generalData.nickName = data.nickName;
        this.generalData.cpf = data.cpf;
        this.generalData.cnhNumber = data.cnhNumber;
        this.generalData.phoneNumber = data.phones[0];

        this.addressData.cep = data.address.cep;
        this.addressData.cityId = data.address.cityId;
        this.addressData.neighborhood = data.address.neighborhood;
        this.addressData.street = data.address.street;
        this.addressData.number = data.address.number;
        this.addressData.complement = data.address.complement;
        this.addressData.state = data.address.stateId;

        this.loadingCity = true;
        try {
          await this.fetchCities(data.address.stateId);
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingCity = false;
        }

        this.vehicleData.typeVehicleId = data.vehicle.typeVehicleId;
        this.vehicleData.renavam = data.vehicle.renavam;
        this.vehicleData.plate = data.vehicle.plate;
        this.vehicleData.description = data.vehicle.description;

        this.bankData.bankName = data.bankData.bankName;
        this.bankData.agency = data.bankData.agency;
        this.bankData.account = data.bankData.account;
        this.bankData.cpfOrCnpjHolder = data.bankData.cpfOrCnpjHolder;
        this.bankData.pixKey = data.bankData.pixKey;
        this.bankData.isHolder = data.bankData.isHolder;

        this.accessData.email = data.email;
        this.accessData.password = data.password;
        this.accessData.confirmPassword = data.confirmPassword;

        data.documentPhotos.map((item) => {
          this.getTypeDocumentPhotos.map((fileItem, index) => {
            if (item.typeDocumentPhotoId === fileItem.id) {
              this.files[index] = {
                ...item,
                dataFiles: `data:image/png;base64,${item.dataFiles}`
              };
            }
          });
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    async getTranshipmentCourier() {
      this.loading = true;
      try {
        const data = await this.getManageTranshipmentDeliverer({ id: this.parameterID });

        this.generalData.name = data.name;
        this.generalData.nickName = data.nickName;
        this.generalData.cpf = data.cpf;
        this.generalData.cnhNumber = data.cnhNumber;
        this.generalData.phoneNumber = data.phoneNumber;

        this.addressData.cep = data.address.cep;
        this.addressData.cityId = data.address.cityId;
        this.addressData.neighborhood = data.address.neighborhood;
        this.addressData.street = data.address.street;
        this.addressData.number = data.address.number;
        this.addressData.complement = data.address.complement;
        this.addressData.state = data.address.stateId;

        this.loadingCity = true;
        try {
          await this.fetchCities(data.address.stateId);
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingCity = false;
        }

        this.vehicleData.typeVehicleId = data.vehicle.typeVehicleId;
        this.vehicleData.renavam = data.vehicle.renavam;
        this.vehicleData.plate = data.vehicle.plate;
        this.vehicleData.description = data.vehicle.description;
        this.accessData.email = data.email;

        this.accessData.password = data.password;
        this.accessData.confirmPassword = data.confirmPassword;

        data.documentPhotos.map((item) => {
          this.getTypeDocumentPhotos.map((fileItem, index) => {
            if (item.typeDocumentPhotoId === fileItem.id) {
              this.files[index] = {
                ...item,
                dataFiles: `data:image/png;base64,${item.dataFiles}`
              };
            }
          });
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss">
#new-courier {
}
</style>
